import { getFormatShortDateFr } from '../../utils';

//FONCTION DE FILTRE ET DE TRI
export function filterAndSortEdls(edls, status, sortBy = 'date', sortOrder = 'asc', searchText = '') {
  return Object.entries(edls)
    .filter((card) => {
      // Vérifier que l'EDL a les propriétés minimales requises
      if (!card[1] || !card[1].metadatas || !card[1].manage || !card[1].possession || !card[1].tenants) {
        return false;
      }
      return status.includes(card[1].metadatas.status);
    })
    .filter((card) => {
      const text = searchText.toLowerCase();
      const date = getFormatShortDateFr(card[1].manage?.dateEDL);
      const tenant = card[1].tenants?.[0] || {};
      const address = card[1].possession?.address || {};
      return text !== ''
        ? (date && date.includes(text)) ||
            (card[1].manage?.typeEDL && card[1].manage.typeEDL.toLowerCase().includes(text)) ||
            (card[1].possession?.typeHouse && card[1].possession.typeHouse.toLowerCase().includes(text)) ||
            (card[1].possession?.typeRent && card[1].possession.typeRent.toLowerCase().includes(text)) ||
            (card[1].possession?.nbRoom && card[1].possession.nbRoom.toLowerCase().includes(text)) ||
            (card[1].possession?.area && String(card[1].possession.area).toLowerCase().includes(text)) ||
            (address.street && address.street.toLowerCase().includes(text)) ||
            (address.complement && address.complement.toLowerCase().includes(text)) ||
            (address.locality && address.locality.toLowerCase().includes(text)) ||
            (address.zipCode && address.zipCode.toLowerCase().includes(text)) ||
            (tenant.civility && tenant.civility.toLowerCase().includes(text)) ||
            (tenant.name && tenant.name.toLowerCase().includes(text)) ||
            (tenant.surname && tenant.surname.toLowerCase().includes(text)) ||
            (tenant.email && tenant.email.toLowerCase().includes(text)) ||
            (tenant.phone && tenant.phone.toLowerCase().includes(text))
        : true;
    })
    .sort((a, b) => {
      if (sortBy === 'date') {
        return sortOrder === 'asc'
          ? new Date(a[1].manage.dateEDL) - new Date(b[1].manage.dateEDL)
          : new Date(b[1].manage.dateEDL) - new Date(a[1].manage.dateEDL);
      } else if (sortBy === 'locality') {
        const result = a[1].possession.address.locality.localeCompare(b[1].possession.address.locality);
        if (sortOrder === 'asc' && result !== 0) {
          return result;
        } else if (sortOrder === 'desc' && result !== 0) {
          return -result;
        } else {
          return new Date(b[1].manage.dateEDL) - new Date(a[1].manage.dateEDL);
        }
      }
      return 1;
    });
}
